import React, { useCallback, useState } from "react";
import { CompanyInfo } from "../../models/company";
import { useUpdateCustomerOrder } from "../../useCases/customerOrder";
import TopCompanyInfo from "../TopCompanyInfo";
import LocaleSelection from "./LocaleSelection";
import { localeFromLocaleKey } from "../../i18n/types";
import { useI18n } from "../../i18n";
import config from "../../config";

import styles from "./styles.module.scss";

interface TopBarProps {
  companyInfo: CompanyInfo;
}

const TopBar: React.FC<TopBarProps> = props => {
  const { companyInfo } = props;
  const { locale, setLocale } = useI18n();
  const [updatingLocale, setUpdatingLocale] = useState(false);

  const updateOrder = useUpdateCustomerOrder();

  const persistLocale = useCallback(
    (newLocale: string) => {
      setUpdatingLocale(true);
      updateOrder(newLocale)
        .catch(err => {
          // silent error, locale is changed before persist
          console.error(err);
        })
        .finally(() => {
          setUpdatingLocale(false);
        });
    },
    [updateOrder]
  );

  const onLocaleSelected = useCallback(
    (newLocaleKey: string) => {
      const newLocale = localeFromLocaleKey(newLocaleKey);
      if (newLocale == null) {
        return;
      }
      setLocale(newLocale);

      // persist order locale
      persistLocale(newLocale);
    },
    [setLocale, persistLocale]
  );

  return (
    <div className={styles.topBar}>
      <TopCompanyInfo companyInfo={companyInfo} />
      {config.feature.customerPortalLocale && (
        <LocaleSelection
          locale={locale}
          onLocaleSelected={onLocaleSelected}
          disabled={updatingLocale}
        />
      )}
    </div>
  );
};

export default TopBar;
